<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { Trade } from '@/libs/invoke';
import store from '@/store';
export default {
    name: 'App',
    async mounted() {
        Trade.getAccountInfo().then(res => {
            if (res.info) {
                store.commit('setTradeAccount', res.info || {});
                store.commit('setEncryptTradeAccount', res.info || {});
            }
        });
    }
};
</script>
<style lang="scss"></style>
